import Handlebars from "hbs";

Handlebars.registerHelper("url_last_substring", function (str) {
  if (str) {
    return str.substring(str.lastIndexOf("/") + 1);
  }

  return "";
});

/* Templates */
import TsProducts from "../../templates/components/troubleshooter/tsproducts.html";
import Troubleshooter from "../../templates/components/troubleshooter/troubleshooter.html";
import TsQuestionAnswers from "../../templates/components/troubleshooter/ts-question-answers.html";
import SkipPopupTemplate from "../../templates/components/troubleshooter/skip-ts-poup.html";
import TsErrorMsg from "../../templates/components/troubleshooter/ts-error-msg.html";
import TsResolved from "../../templates/components/troubleshooter/ts-resolved.html";

/* TS Family jsons */
import TSMXFamilies from "../../copy/uk/troubleshootersMXFamilies.json";

import TsInterpreter from "./tsInterpreter";
import { getDevice } from "../util/getDeviceByModelCode";
import SaLogin from "./saLogin";

export default class TsApi {
  constructor(selectedProduct) {
    // console.log('selectedProduct tsapi',selectedProduct)
    this.selectedProduct = selectedProduct;
    this.init();
    this.events();
  }

  init() {
    const baseURL = window.state.apihost + "/uk/repair-booking/lucid-ts-api/";
    this.liveProductAPI = baseURL + "product/";
    this.sessionAPI = baseURL + "session/";
    this.initalStepAPI = baseURL + "initialstep/";
    this.nextStepAPI = baseURL + "nextstep/";
    this.scriptStepAPI = baseURL + "scriptstep/";
    this.symptomCodeAPI = baseURL + "symptomcode/";
    this.scenarioAPI = baseURL + "scenario/";

    this.xSessionToken = "";
    this.sessionId = "";
    this.selectedProductId = "";
    this.selectedProdName = "";
    this.selectedProdImg = "";
    this.selectedScriptId = "";
    this.ref = "";
    this.selectedStepIds = [];
    this.skipSteps = [];
    this.skipReturned = false;
    this.faultCode = null;
    this.response = null;
    this.tsOutcome = {};
    this.numberOfTimeNextStepCalled = 0;
    this.isOutcomeSuccessful = null;
    this.embeddedPagelets = [];
    this.embeddedFAQs = [];
    this.embeddedFAQsHTMLSteps = [];
    this.deviceFamily = "";
    this.deviceFamilyList = [];
    this.openChat = false;
    this.listView = false;
    this.evaluateProperty = null;

    this.templates = {};
    this.templates.tsProducts = TsProducts;
    this.templates.troubleshooter = Troubleshooter;
    this.templates.tsquestionanswers = TsQuestionAnswers;
    this.templates.skipPopupTemplate = SkipPopupTemplate;
    this.templates.tsErrorMsg = TsErrorMsg;
    this.templates.tsResolved = TsResolved;

    // QAJourney recording
    if (window.location.host.includes("p6-qa")) {
      this.QAJourney = [];
    }

    var scripts = document.getElementsByTagName("script");
    var fontAwesomeExists = false;

    for (var i = scripts.length; i--; ) {
      if (scripts[i].src == "https://kit.fontawesome.com/8f542368be.js") {
        fontAwesomeExists = true;
      }
    }

    if (!fontAwesomeExists) {
      // insert fontawesome
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://kit.fontawesome.com/8f542368be.js";
      script.crossorigin = "anonymous";

      document.head.appendChild(script);
    }

    this.showTroubleshooter();
  }

  events() {
    var $this = this;

    // QAJourney recording
    if (window.location.host.includes("p6-qa")) {
      $("#products-container .col.product")
        .off("click")
        .on("click", function (e) {
          $this.QAJourney = [];
          console.log($this.QAJourney, "QAJourney Test");
        });
    }

    $("#ts-product-container .product-wrapper")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();

        if ($(this).hasClass("product-wrapper-family")) {
          $this.deviceFamily = $(this).data("prod-family");
          $this.showTroubleshooter();
        } else {
          $this.selectedProductId = $(this).data("prod-id");
          $this.selectedProdName = $(this).data("prod-name");
          $this.selectedProdImg = $(this).find("img").attr("src");

          window.state._productName = $this.selectedProdName
          $this.initSession();
        }
      });

    $("#tsQAWrapper #answers a")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();

        if (document.querySelector(".lucidref strong")) {
          window.state._tsRef =
            document.querySelector(".lucidref strong").innerText;
        }

        if (!$(e.target).hasClass("btn-ts-pagelet")) {
          // add this to disable multiple clicks
          $(this).parent().addClass("answers--disabled");

          if ($(e.target).attr("has-skip")) {
            var answerId = $(this).attr("id");
            var stepId = $(this).attr("step-id");
            $this.selectedStepIds.push(stepId);
            var lastSkip = $this.skipSteps[$this.skipSteps.length - 1][0];

            $this.initscriptStep(lastSkip, answerId);
          } else {
            var answerId = $(this).attr("id");
            var stepId = $(this).attr("step-id");
            $this.selectedStepIds.push(stepId);

            $this.initnextStep(answerId);
          }
        }

        // POP Answers active POP journey
        let POPAnswerIDs = ["866694", "380045", "249142", "920623", "249144", "886911", "557884", "630091", "543481", "686830", "283823", "467142", "305857", "632720", "458322", "763787", "520830", "909614", "909764", "909927", "910016", ""]

        if (POPAnswerIDs.includes(e.target.id)) {
          window.state._popJourney.push(e.target.id)
        }

        // KISS Answers on initial page to break journey, temp fix for iframe variables (missingdamaged / delivery damage)
        let KISSAnswersIDs = ["910218", "910220", "910207", "910209", "910187"];
        let KISSAnswersIDsForm = ["909633", "909774", "909932", "910025"];
        //
        if (KISSAnswersIDs.includes(e.target.id)) {
          // post to window object as this use to be sent via the Iframe
          window.postMessage({
            type: "lcxtsmessage",
            sessionId: $(".lucidref strong").text(),
            outcome: "missingdamaged",
          });
        }

        if (KISSAnswersIDsForm.includes(e.target.id)) {
          window.postMessage({
            type: "tsoutcome",
            sessionId: "",
            product: window.state._product,
            selectedIssue: "",
            symptomCode1: "99",
            symptomCode2: "99",
            symptomCode3: "99",
            outcome: "ihkissbooking",
          });
        }

        // QAJourney recording
        if (window.location.host.includes("p6-qa")) {
          $this.QAJourney.push($(this).text());
          console.log($this.QAJourney, "QAJourney Test");
        }

        // OOW Smartphones and Tab answers
        let OOWAnwsers = ['866694','380044', '380045', '866696', '866697', '866698']

        if (OOWAnwsers.includes(e.target.id)) {
          window.state._wtyException = "VOID1";
        } else {
          if (window.state._wtyException) {
            delete window.state._wtyException
          }
        }

      });

    $("#tsQAWrapper .prev-step")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        e.target.setAttribute("disabled", "disabled");

        // QAJourney recording
        if (window.location.host.includes("p6-qa")) {
          $this.QAJourney.splice(-1);
          console.log($this.QAJourney, "QAJourney Test");
        }

        $this.initscriptStep();
      });

    /**$('#tsQAWrapper .skip-ts').off('click').on('click', function(e) {

            e.preventDefault();
            $this.isOutcomeSuccessful = false;
            $this.buildTSOutcomeObject();

        });**/

    $("#tsQAWrapper .skip-ts")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();

        if ($("#ts-skip-popup-wrapp").length) {
          $("#ts-skip-popup-wrapp").remove();
        }

        if ($("footer.footer").length > 0) {
          $($this.templates.skipPopupTemplate).insertAfter("footer.footer");
        }

        if ($("footer#footer").length > 0) {
          $($this.templates.skipPopupTemplate).insertAfter("footer#footer");
        }

        $(".ts-skip-popup").show();
        $(".s-layer-dimmed").css("opacity", 0.8);
        $(".s-layer-dimmed").show();

        var focusable = document
          .querySelector(".ts-skip-popup")
          .querySelectorAll("input,button,select,textarea");

        if (focusable.length) {
          // focusable[0].parentElement.focus();
          // document.querySelector('#_ts_skipTSPopupContainer').focus();
          $this.addFocus(focusable[0]);
        }

        $this.events();
      });

    $(".ts-skip-popup .ts-repair-button")
      .off("click")
      .on("click", function (event) {
        event.preventDefault();
        $this.isOutcomeSuccessful = false;

        $this.sessionId += "-SKIP";

        $this.buildTSOutcomeObject();

        setTimeout(() => {
          $(".ts-skip-popup").hide();
          $(".s-layer-dimmed").hide();
        }, 1000);
      });

    $(".ts-skip-popup #ts-skip-popup-close")
      .off("click")
      .on("click", function (event) {
        event.preventDefault();
        $(".ts-skip-popup").hide();
        $(".s-layer-dimmed").hide();
      });

    $(".ts-skip-popup .ts-back-button")
      .off("click")
      .on("click", function (event) {
        event.preventDefault();
        $(".ts-skip-popup").hide();
        $(".s-layer-dimmed").hide();
      });

    $("#troubleshooting-guide #cmbDevs")
      .off("change")
      .on("change", function (e) {
        e.preventDefault();

        $this.selectedProductId = this.value;
        $this.selectedProdName =
          this.options[this.selectedIndex].getAttribute("data-prod-name");
        $this.initSession();
      });

    $("#troubleshooting-guide #cmbFamilies")
      .off("change")
      .on("change", function (e) {
        e.preventDefault();

        $this.deviceFamily =
          this.options[this.selectedIndex].getAttribute("data-prod-family");
        $this.showTroubleshooter();
      });

    $("#troubleshooting-guide .ts-message")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.buildTSOutcomeObject();
      });

    $("#tsQAWrapper")
      .off("click")
      .on("click", ".ts-scen-reference", function (e) {
        if (e.target.classList.contains("ts-scen-reference__header")) {
          e.target.parentElement.remove();
        }
      });

    const supportPageButtonExists = setInterval(() => {
      if (document.querySelector(".ts-scen-further-support-button")) {
        $(".ts-scen-further-support-button")
          .off("click")
          .on("click", function (e) {
            e.preventDefault();
            window.location.href = "https://www.samsung.com/uk/support/";
          });

        $(".ts-scen-close-button")
          .off("click")
          .on("click", function (e) {
            e.preventDefault();
            $this.scrollTo("#choose-your-product", 100);
            $("#troubleshooting-guide").html("");
            $("#troubleshooting-guide").hide();
          });

        clearInterval(supportPageButtonExists);
      }
    }, 200);

    // end screen buttons
    // .ts-scen-button - removed this target - Iframe
    $(".ts-message")
      .off("click")
      .on("click", function (e) {
        if (
          e.target.classList.contains("ts-message") &&
          e.target.getAttribute("data-ts-message") == '["clickedChatToAgent"]'
        ) {
          e.preventDefault();
          $this.handleClickedChatToAgent();
        } else if (
          e.target.classList.contains("_ts_style_backIcon") &&
          e.target.parentElement.getAttribute("data-ts-message") ==
            '["clickedChatToAgent"]'
        ) {
          e.preventDefault();
          $this.handleClickedChatToAgent();
        } else if (
          e.target.classList.contains("ts-message") &&
          e.target.getAttribute("data-ts-message") == '["resolved"]'
        ) {
          e.preventDefault();
          $this.showTSResolved();
        } else if (
          e.target.classList.contains("ts-message") &&
          e.target.getAttribute("data-ts-message") == '["ihIIbooking"]' &&
          e.target.textContent.includes("No")
        ) {
          e.preventDefault();
          let remove1 = e.target
            .getAttribute("data-ts-message")
            .replace('["', "");
          let remove2 = remove1.replace('"]', "");

          window.postMessage({
            type: "lcxtsmessage",
            sessionId: $this.sessionId,
            outcome: remove2,
          });
        } else if (
          // post to window object as this use to be sent via the Iframe
          (e.target.classList.contains("ts-message") &&
            e.target.getAttribute("data-ts-message") == '["otherissue"]') ||
          (e.target.classList.contains("ts-message") &&
            e.target.getAttribute("data-ts-message") == '["ihIIbooking"]')
        ) {
          e.preventDefault();

          let remove1 = e.target
            .getAttribute("data-ts-message")
            .replace('["', "");
          let remove2 = remove1.replace('"]', "");

          window.postMessage({
            type: "lcxtsmessage",
            sessionId: "",
            outcome: remove2,
          });
        } else if (
          e.target.classList.contains("ts-message") &&
          e.target.getAttribute("data-ts-message") == '["ihkissbooking"]'
        ) {
          e.preventDefault();

          let remove1 = e.target
            .getAttribute("data-ts-message")
            .replace('["', "");
          let remove2 = remove1.replace('"]', "");

          window.postMessage({
            type: "tsoutcome",
            sessionId: "",
            product: window.state._product,
            selectedIssue: "",
            symptomCode1: "99",
            symptomCode2: "99",
            symptomCode3: "99",
            outcome: remove2,
          });

        } else if (
          (e.target.classList.contains("ts-message") &&
          e.target.getAttribute("data-ts-message") == '["clickedBatteryReplacementService"]') ||
          (e.target.classList.contains("_ts_style_backIcon") &&
          e.target.parentElement.getAttribute("data-ts-message") == '["clickedBatteryReplacementService"]')
        ) {
          e.preventDefault();

          window.state.isBatteryReplacement = true;

          // Get the session ID if available
          const sessionId = $(".lucidref strong").text() || "";

          // Add this crucial line - initialize _tsoutcome if it doesn't exist
          if (!window.state._tsoutcome) {
            window.state._tsoutcome = {};
          }

          // Set the display name - this prevents the TypeError
          window.state._tsoutcome.tsProductNameForDisplay = $this.selectedProdName || window.state._product || "Galaxy Device";

          window.state.tsoutcome = {
            lucidRef: sessionId,
            outcome: "Unsuccessful",
            symptomCode1: "99",
            symptomCode2: "99",
            symptomCode3: "99",
            warrantyException: "",
            selectedIssue: "Battery Replacement",
            troubleshootedProduct: "Samsung/" + ($this.selectedProdName || window.state._product || "Galaxy Device"),
            tsProductNameForDisplay: $this.selectedProdName || window.state._product || "Galaxy Device"
          };

          // Now that the required state is set up, we can build the outcome object
          $this.buildTSOutcomeObject();

        } else {
          e.preventDefault();
          $this.buildTSOutcomeObject();
        }
      });

    //Pagelet
    // $('#tsQAWrapper button.btn-ts-pagelet').off('click').on('click', function(e) {

    //     var thisPageletID = $(this).data('tsId');
    //     var thisTitle = $(this).text();
    //     var thisPageletImage = '';

    //     if ($this.embeddedPagelets) {
    //         $this.embeddedPagelets.map(function(pagelets){
    //             if (thisPageletID === pagelets.id) {
    //                 thisPageletImage = pagelets.bodyText;
    //             }
    //         });
    //     }

    //     var showContent = function() {
    //         if (thisTitle == 'reference number') {
    //             return $this.sessionId
    //         } else {
    //             // console.log(thisPageletID, 'thisPageletID')
    //             // console.log(thisPageletImage, 'thisPageletImage')

    //             return (`
    //                 <div class="ts-scen-reference__image-container">
    //                     ${thisPageletImage}
    //                 </div>
    //             `)
    //         }
    //     }

    //     if ($(this).parent().next().hasClass('ts-scen-reference')) {
    //         if ($(this).parent().parent().find(`.ts-scen-id-${thisPageletID}`).length !== 0) {
    //             $(this).parent().parent().find(`.ts-scen-id-${thisPageletID}`).remove()
    //         } else {
    //             if ($(this).next().next().next().hasClass('ts-shared-term')) {
    //                 $(this).next().before(`
    //                     <div class="ts-scen-reference ts-scen-id-${thisPageletID}">
    //                         <div class="ts-scen-reference__header">${thisTitle}</div>
    //                         <div class="ts-scen-reference__content">
    //                             ${showContent()}
    //                         </div>
    //                     </div>
    //                 `)

    //                 $(this).next('.ts-scen-reference').addClass('ts-scen-reference--show')
    //             } else {
    //                 $(this).parent().after(`
    //                     <div class="ts-scen-reference ts-scen-id-${thisPageletID}">
    //                         <div class="ts-scen-reference__header">${thisTitle}</div>
    //                         <div class="ts-scen-reference__content">
    //                             ${showContent()}
    //                         </div>
    //                     </div>
    //                 `)

    //                 $(this).parent().next('.ts-scen-reference').addClass('ts-scen-reference--show')
    //             }
    //         }

    //     } else if ($(this).next('br').length || $(this).next(`.ts-scen-id-${thisPageletID}`).length || $(this).next(`.ts-shared-term`).length) {
    //         if ($(this).siblings(`.ts-scen-id-${thisPageletID}`).length) {
    //             $(`.btn-ts-pagelet[data-ts-id="${thisPageletID}"]`).siblings('.ts-scen-reference').remove()
    //         } else {
    //             if ($('button.btn-ts-pagelet').siblings('br').length) {
    //                 $(`
    //                     <div class="ts-scen-reference ts-scen-id-${thisPageletID}">
    //                         <div class="ts-scen-reference__header">${thisTitle}</div>
    //                         <div class="ts-scen-reference__content">
    //                             ${showContent()}
    //                         </div>
    //                     </div>
    //                 `).insertBefore($(this).nextAll('br:first'))

    //                 $(this).siblings('.ts-scen-reference').addClass('ts-scen-reference--show')

    //             } else {
    //                 $(this).parent().after(`
    //                     <div class="ts-scen-reference ts-scen-id-${thisPageletID}">
    //                         <div class="ts-scen-reference__header">${thisTitle}</div>
    //                         <div class="ts-scen-reference__content">
    //                             ${showContent()}
    //                         </div>
    //                     </div>
    //                 `)

    //                 $(this).parent().next('.ts-scen-reference').addClass('ts-scen-reference--show')
    //             }

    //         }

    //     } else if($(this).prev('button').length && $(this).prev('button').hasClass('btn-ts-inline-scenario')) {
    //         if ($(this).next('.tsQAWrapper__faq-container').length && $(this).nextAll('.ts-scen-reference:eq(0)').length < 1) {
    //             $(this).next('.tsQAWrapper__faq-container').after(`
    //                 <div class="ts-scen-reference ts-scen-id-${thisPageletID}">
    //                     <div class="ts-scen-reference__header">${thisTitle}</div>
    //                     <div class="ts-scen-reference__content">
    //                         ${showContent()}
    //                     </div>
    //                 </div>
    //             `)

    //             $(this).nextAll('.ts-scen-reference:eq(0)').addClass('ts-scen-reference--show')
    //         } else {
    //             $(this).nextAll('.ts-scen-reference:eq(0)').remove();
    //         }
    //     }
    //     else if ($(this).siblings('.ts-scen-button.ts-message').length > 0){
    //         if ($(this).nextAll('.tsQAWrapper__faq-container').length < 1 && $(this).nextAll('.ts-scen-reference:eq(0)').length < 1) {
    //             $(this).parent().find('.ts-scen-button.ts-message').before(`
    //                 <div class="ts-scen-reference ts-scen-id-${thisPageletID}">
    //                     <div class="ts-scen-reference__header">${thisTitle}</div>
    //                     <div class="ts-scen-reference__content">
    //                         ${showContent()}
    //                     </div>
    //                 </div>
    //             `)

    //             $(this).siblings('.ts-scen-reference').addClass('ts-scen-reference--show')
    //         } else {
    //             $(this).nextAll('.ts-scen-reference:eq(0)').remove();
    //         }
    //     } else {
    //         $(this).parent().after(`
    //             <div class="ts-scen-reference ts-scen-id-${thisPageletID}">
    //                 <div class="ts-scen-reference__header">${thisTitle}</div>
    //                 <div class="ts-scen-reference__content">
    //                     ${showContent()}
    //                 </div>
    //             </div>
    //         `)

    //         $(this).parent().next('.ts-scen-reference').addClass('ts-scen-reference--show')
    //     }
    // })

    // $('#tsQAWrapper').off('click', '.ts-scen-reference__header').on('click', '.ts-scen-reference__header', function(e) {
    //     $(this).closest('.ts-scen-reference').remove()
    // })
    // Event Handler Setup
    $("#tsQAWrapper button.btn-ts-pagelet")
      .off("click")
      .on("click", function (e) {
        var thisPageletID = $(this).data("tsId");
        var thisTitle = $(this).text();
        var thisPageletImage = "";

        if ($this.embeddedPagelets) {
          $this.embeddedPagelets.forEach(function (pagelet) {
            if (thisPageletID === pagelet.id) {
              thisPageletImage = pagelet.bodyText;
            }
          });
        }

        handleScenarioReference.call(
          this,
          thisPageletID,
          thisTitle,
          thisPageletImage
        );
      });
    // Handle Scenario Reference
    function handleScenarioReference(
      thisPageletID,
      thisTitle,
      thisPageletImage
    ) {
      // Define showContent function here to access thisPageletID, thisTitle, and thisPageletImage
      var showContent = function () {
        if (thisTitle === "reference number") {
          // Example condition, adjust according to your actual logic
          return "Session ID content"; // Adjust this line to actually fetch the session ID if needed
        } else {
          return `
                        <div class="ts-scen-reference__image-container">
                            ${thisPageletImage}
                        </div>
                    `;
        }
      };

      insertOrUpdateScenReference.call(
        this,
        thisPageletID,
        thisTitle,
        showContent
      );
    }
    // Insert or Update Scenario Reference
    function insertOrUpdateScenReference(
      thisPageletID,
      thisTitle,
      showContentFunc
    ) {
      const $this = $(this);
      const $thisParent = $this.parent();
      const $nextSiblingOfParent = $thisParent.next();

      // Local function to insert scenario reference
      const insertScenReference = (positionReference, method, content) => {
        let $content = $(content);
        if (method === "before") {
          positionReference.before($content);
        } else if (method === "after") {
          positionReference.after($content);
        } else if (method === "insertBefore") {
          $content.insertBefore(positionReference);
        }
        $content.addClass("ts-scen-reference--show");
      };

      // Local function to remove scenario reference
      const removeScenReference = (selector) => {
        $(selector).remove();
      };

      // Generate content dynamically based on showContentFunc
      let content = `
                <div class="ts-scen-reference ts-scen-id-${thisPageletID}">
                    <div class="ts-scen-reference__header">${thisTitle}</div>
                    <div class="ts-scen-reference__content">
                        ${showContentFunc()}
                    </div>
                </div>
            `;

      // Conditions for determining where to insert the content
      if ($nextSiblingOfParent.hasClass("ts-scen-reference")) {
        if (
          $thisParent.parent().find(`.ts-scen-id-${thisPageletID}`).length !== 0
        ) {
          removeScenReference(`.ts-scen-id-${thisPageletID}`);
        } else {
          const $nextNextNextSibling = $this.next().next().next();
          if ($nextNextNextSibling.hasClass("ts-shared-term")) {
            insertScenReference($this.next(), "before", content);
          } else if ($nextNextNextSibling) {
            if (
              $this.data("ts-id") == 1111117545 ||
              $this.data("ts-id") == 1111117538 ||
              $this.data("ts-id") == 1111117540
            ) {
              insertScenReference($this.nextAll("br:first"), "before", content);
            } else {
              insertScenReference($this.next(), "before", content);
            }
          } else {
            insertScenReference($thisParent, "after", content);
          }
        }
      } else if (
        $this.next("br").length ||
        $this.next(`.ts-scen-id-${thisPageletID}`).length ||
        $this.next(`.ts-shared-term`).length
      ) {
        if ($this.siblings(`.ts-scen-id-${thisPageletID}`).length) {
          let thisTarget = $(`.btn-ts-pagelet[data-ts-id="${thisPageletID}"]`)
            .siblings(".ts-scen-reference")
            .remove();
          removeScenReference(thisTarget);
        } else {
          const $nextBr = $this.nextAll("br:first");
          if ($nextBr.length) {
            insertScenReference($nextBr, "insertBefore", content);
          } else {
            insertScenReference($thisParent, "after", content);
          }
        }
      } else if (
        $this.prev("button").length &&
        $this.prev("button").hasClass("btn-ts-inline-scenario")
      ) {
        const $nextFAQContainer = $this.next(".tsQAWrapper__faq-container");
        if (
          $nextFAQContainer.length &&
          $this.nextAll(".ts-scen-reference:eq(0)").length < 1
        ) {
          insertScenReference($nextFAQContainer, "after", content);
        } else {
          removeScenReference($this.nextAll(".ts-scen-reference:eq(0)"));
        }
      } else if ($this.siblings(".ts-scen-button.ts-message").length > 0) {
        if (
          $this.nextAll(".tsQAWrapper__faq-container").length < 1 &&
          $this.nextAll(".ts-scen-reference:eq(0)").length < 1
        ) {
          insertScenReference(
            $thisParent.find(".ts-scen-button.ts-message"),
            "before",
            content
          );
        } else {
          removeScenReference($this.nextAll(".ts-scen-reference:eq(0)"));
        }
      } else {
        insertScenReference($thisParent, "after", content);
      }
    }

    //Scenarios

    if ($("#tsQAWrapper button.btn-ts-inline-scenario").length != 0) {
      const FAQStepsExists = setInterval(() => {
        if (this.embeddedFAQsHTMLSteps) {
          var faqSteps = [];

          $("#tsQAWrapper button.btn-ts-inline-scenario").each(function (
            index,
            scenario
          ) {
            $this.embeddedFAQsHTMLSteps.map((faq) => {
              if (faq.id == $(this).data("tsId")) {
                faqSteps = faq.steps;
              }
            });

            if ($(this).next("br").length) {
              $(`
                                <div class="tsQAWrapper__faq-container">
                                    <div class="tsQAWrapper__faq-header">Show me</div>
                                    <div class="tsQaWrapper__faq-content">
                                    <table>
                                    ${faqSteps
                                      .map(
                                        (steps) =>
                                          `<tr>${steps.rawContent}</tr>`
                                      )
                                      .join("")}
                                    </table>
                                    </div>
                                </div>
                            `).insertBefore($(this).next("br"));

              $(this)
                .off("click")
                .on("click", function (e) {
                  $(this)
                    .next(".tsQAWrapper__faq-container")
                    .find(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                  $(this)
                    .next(".tsQAWrapper__faq-container")
                    .find(".tsQAWrapper__faq-header")
                    .toggleClass("tsQAWrapper__faq-header--show");
                });

              $(this)
                .next(".tsQAWrapper__faq-container")
                .find(".tsQAWrapper__faq-header")
                .off("click")
                .on("click", function (e) {
                  $(this).toggleClass("tsQAWrapper__faq-header--show");
                  $(this)
                    .next(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                });
            } else if ($(this).parent("span").next("br").length) {
              $(`
                                <div class="tsQAWrapper__faq-container">
                                    <div class="tsQAWrapper__faq-header">Show me</div>
                                    <div class="tsQaWrapper__faq-content">
                                    <table>
                                        ${faqSteps
                                          .map(
                                            (steps) =>
                                              `<tr>${steps.rawContent}</tr>`
                                          )
                                          .join("")}
                                        </table>
                                    </div>
                                </div>
                            `).insertBefore($(this).parent("span").next("br"));

              $(this)
                .off("click")
                .on("click", function (e) {
                  $(this)
                    .parent()
                    .next(".tsQAWrapper__faq-container")
                    .find(".tsQAWrapper__faq-header")
                    .toggleClass("tsQAWrapper__faq-header--show");
                  $(this)
                    .parent()
                    .next(".tsQAWrapper__faq-container")
                    .find(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                });

              $(this)
                .parent()
                .next(".tsQAWrapper__faq-container")
                .find(".tsQAWrapper__faq-header")
                .off("click")
                .on("click", function (e) {
                  $(this).toggleClass("tsQAWrapper__faq-header--show");
                  $(this)
                    .next(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                });
            } else if (
              $(this).next("button").length &&
              $(this).next("button").hasClass("btn-ts-pagelet")
            ) {
              $(`
                                <div class="tsQAWrapper__faq-container">
                                    <div class="tsQAWrapper__faq-header">Show me</div>
                                    <div class="tsQaWrapper__faq-content">
                                    <table>
                                    ${faqSteps
                                      .map(
                                        (steps) =>
                                          `<tr>${steps.rawContent}</tr>`
                                      )
                                      .join("")}
                                    </table>
                                    </div>
                                </div>
                            `).insertBefore($(this).nextAll("br:eq(0)"));

              $(this)
                .off("click")
                .on("click", function (e) {
                  $(this)
                    .nextAll(".tsQAWrapper__faq-container:eq(0)")
                    .find(".tsQAWrapper__faq-header")
                    .toggleClass("tsQAWrapper__faq-header--show");
                  $(this)
                    .nextAll(".tsQAWrapper__faq-container:eq(0)")
                    .find(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                });

              $(this)
                .nextAll(".tsQAWrapper__faq-container:eq(0)")
                .find(".tsQAWrapper__faq-header")
                .off("click")
                .on("click", function (e) {
                  $(this).toggleClass("tsQAWrapper__faq-header--show");
                  $(this)
                    .next(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                });
            } else if (
              $(this).next("span").length &&
              $(this).next("span").hasClass("ts-shared-term")
            ) {
              $(`
                                <div class="tsQAWrapper__faq-container">
                                    <div class="tsQAWrapper__faq-header">Show me</div>
                                    <div class="tsQaWrapper__faq-content">
                                    <table>
                                    ${faqSteps
                                      .map(
                                        (steps) =>
                                          `<tr>${steps.rawContent}</tr>`
                                      )
                                      .join("")}
                                    </table>
                                    </div>
                                </div>
                            `).insertBefore($(this).nextAll("br:eq(0)"));

              $(this)
                .off("click")
                .on("click", function (e) {
                  $(this)
                    .nextAll(".tsQAWrapper__faq-container:eq(0)")
                    .find(".tsQAWrapper__faq-header")
                    .toggleClass("tsQAWrapper__faq-header--show");
                  $(this)
                    .nextAll(".tsQAWrapper__faq-container:eq(0)")
                    .find(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                });

              $(this)
                .nextAll(".tsQAWrapper__faq-container:eq(0)")
                .find(".tsQAWrapper__faq-header")
                .off("click")
                .on("click", function (e) {
                  $(this).toggleClass("tsQAWrapper__faq-header--show");
                  $(this)
                    .next(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                });
            } else if ($(this).next().hasClass("btn-ts-inline-scenario")) {
              $(`
                                <div class="tsQAWrapper__faq-container">
                                    <div class="tsQAWrapper__faq-header">Show me</div>
                                    <div class="tsQaWrapper__faq-content">
                                    <table>
                                    ${faqSteps
                                      .map(
                                        (steps) =>
                                          `<tr>${steps.rawContent}</tr>`
                                      )
                                      .join("")}
                                    </table>
                                    </div>
                                </div>
                            `).insertBefore($(this).nextAll("br:eq(0)"));

              $(this)
                .off("click")
                .on("click", function (e) {
                  $(this)
                    .nextAll(".tsQAWrapper__faq-container:eq(0)")
                    .find(".tsQAWrapper__faq-header")
                    .toggleClass("tsQAWrapper__faq-header--show");
                  $(this)
                    .nextAll(".tsQAWrapper__faq-container:eq(0)")
                    .find(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                });

              $(this)
                .nextAll(".tsQAWrapper__faq-container:eq(0)")
                .find(".tsQAWrapper__faq-header")
                .off("click")
                .on("click", function (e) {
                  $(this).toggleClass("tsQAWrapper__faq-header--show");
                  $(this)
                    .next(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                });
            } else if ($(this).next().hasClass("tsQAWrapper__faq-container")) {
              $(`
                                <div class="tsQAWrapper__faq-container">
                                    <div class="tsQAWrapper__faq-header">Show me</div>
                                    <div class="tsQaWrapper__faq-content">
                                    <table>
                                    ${faqSteps
                                      .map(
                                        (steps) =>
                                          `<tr>${steps.rawContent}</tr>`
                                      )
                                      .join("")}
                                    </table>
                                    </div>
                                </div>
                            `).insertBefore($(this).nextAll("br:eq(0)"));

              $(this)
                .off("click")
                .on("click", function (e) {
                  $(this)
                    .nextAll(".tsQAWrapper__faq-container:eq(1)")
                    .find(".tsQAWrapper__faq-header")
                    .toggleClass("tsQAWrapper__faq-header--show");
                  $(this)
                    .nextAll(".tsQAWrapper__faq-container:eq(1)")
                    .find(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                });

              $(this)
                .nextAll(".tsQAWrapper__faq-container:eq(1)")
                .find(".tsQAWrapper__faq-header")
                .off("click")
                .on("click", function (e) {
                  $(this).toggleClass("tsQAWrapper__faq-header--show");
                  $(this)
                    .next(".tsQaWrapper__faq-content")
                    .toggleClass("tsQaWrapper__faq-content--show");
                });
            } else {
              if (
                $(this).parent().next(".tsQAWrapper__faq-container").length <
                  1 &&
                $(".tsQAWrapper__faq-container").length <
                  $(".btn-ts-inline-scenario").length
              ) {
                $(this).parent().after(`
                                    <div class="tsQAWrapper__faq-container">
                                        <div class="tsQAWrapper__faq-header">Show me</div>
                                        <div class="tsQaWrapper__faq-content">
                                        <table>
                                            ${faqSteps
                                              .map(
                                                (steps) =>
                                                  `<tr>${steps.rawContent}</tr>`
                                              )
                                              .join("")}
                                            </table>
                                        </div>

                                    </div>
                                `);

                $(this)
                  .off("click")
                  .on("click", function (e) {
                    $(this)
                      .parent()
                      .next(".tsQAWrapper__faq-container")
                      .find(".tsQAWrapper__faq-header")
                      .toggleClass("tsQAWrapper__faq-header--show");
                    $(this)
                      .parent()
                      .next(".tsQAWrapper__faq-container")
                      .find(".tsQaWrapper__faq-content")
                      .toggleClass("tsQaWrapper__faq-content--show");
                  });

                $(this)
                  .parent()
                  .next(".tsQAWrapper__faq-container")
                  .find(".tsQAWrapper__faq-header")
                  .off("click")
                  .on("click", function (e) {
                    $(this).toggleClass("tsQAWrapper__faq-header--show");
                    $(this)
                      .next(".tsQaWrapper__faq-content")
                      .toggleClass("tsQaWrapper__faq-content--show");
                  });
              }
            }
          });

          clearInterval(FAQStepsExists);
        }
      }, 500);
    }
  }

  addFocus(ele) {
    ele.focus();
  }

  showTroubleshooter() {
    window.state.isBatteryReplacement = false;
    this.addOverlay();

    var headerObj = {};

    this.apiGet(
      this.liveProductAPI,
      headerObj,
      this.processLiveProductApiResponse
    );
  }

  filterSmartphones(device) {
    if (device.includes("Galaxy S")) {
      return "ts-s-series-family";
    }

    if (device.includes("Galaxy Z")) {
      return "ts-flip-fold-series-family";
    }

    if (device.includes("Galaxy A")) {
      return "ts-a-series-family";
    }

    if (device.includes("Galaxy J")) {
      return "ts-j-series-family";
    }

    if (device.includes("Galaxy M")) {
      return "ts-m-series-family";
    }

    if (device.includes("Galaxy Note")) {
      return "ts-note-series-family";
    }
  }

  filterTablets(device) {
    if (device.includes("Galaxy Tab S")) {
      return "ts-tablets-tab-s-family";
    }

    if (device.includes("Galaxy Tab Active")) {
      return "ts-tablets-tab-rugged-family";
    }

    if (device.includes("Galaxy Tab A")) {
      return "ts-tablets-tab-a-family";
    }

    if (device.includes("Galaxy TabPro")) {
      return "ts-tablets-tab-other-family";
    }
  }

  processLiveProductApiResponse(res, $this) {
    // console.log(res, 'do we get here at any point on dev')
    if (res.success) {
      let device = "";

      let response = res.data;

      if (
        window.state.saProductDetail.length > 0 &&
        window.state.saProductDetail[0].deviceModelID != ""
      ) {
        let sku = window.state.saProductDetail[0].deviceModelID;
        device = getDevice(sku);
      }

      if ($this.selectedProduct == "Smartphones" && !$this.deviceFamily) {
        if (
          window.state.saProductDetail.length > 0 &&
          window.state.saProductDetail[0].deviceModelID != ""
        ) {
          $this.deviceFamily = $this.filterSmartphones(device);

          let filteredRes = $this.filterByTypes(response, device);

          let deviceObj = filteredRes.find((o) => o.model === device);

          $this.selectedProductId = deviceObj.id;
          $this.selectedProdName = deviceObj.model;



          let imageUrl = deviceObj.smallImage.imageUrl;
          let imageName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);

          $this.selectedProdImg =
            "https://samsung.likewizesupport.com/cx-cdn/images/devices/" + imageName;

          window.supportComponents.steps.setActiveStep(2);
          $this.initSession();
        } else {
          $this.deviceFamilyList = TSMXFamilies.Smartphones;
          $this.showProducts(TSMXFamilies.Smartphones);
        }
      } else if ($this.selectedProduct == "Tablets" && !$this.deviceFamily) {
        if (
          window.state.saProductDetail.length > 0 &&
          window.state.saProductDetail[0].deviceModelID != ""
        ) {
          $this.deviceFamily = $this.filterTablets(device);

          let filteredRes = $this.filterByTypes(response, device);
          let deviceObj = filteredRes.find((o) => o.model === device);


          $this.selectedProductId = deviceObj.id;
          $this.selectedProdName = deviceObj.model;

          let imageUrl = deviceObj.smallImage.imageUrl;
          let imageName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);

          $this.selectedProdImg =
            "https://samsung.likewizesupport.com/cx-cdn/images/devices/" + imageName;

          window.supportComponents.steps.setActiveStep(2);
          $this.initSession();
        } else {
          $this.deviceFamilyList = TSMXFamilies.Tablets;
          $this.showProducts(TSMXFamilies.Tablets);
        }
      } else {
        var filteredRes = $this.filterByTypes(response, device);

        if (filteredRes.length == 1 && !$this.listView) {
          // console.log(filteredRes);
          //console.log(filteredRes[0].id);
          $this.selectedProductId = filteredRes[0].id;
          $this.selectedProdName = filteredRes[0].model;

          let imageUrl = filteredRes[0].smallImage.imageUrl;
          let imageName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);

          $this.selectedProdImg =
            "https://samsung.likewizesupport.com/cx-cdn/images/devices/" + imageName;

          window.supportComponents.steps.setActiveStep(2);
          $this.initSession();
        } else {
          $this.showProducts(filteredRes);
        }
      }
    } else {
      console.log("Product req failed");
      $this.showTsErrorMsg();
    }
  }

  showProducts(filteredRes) {
    var $this = this;

    var showFilter =
      this.selectedProduct != "TV" &&
      this.selectedProduct != "Monitor" &&
      this.selectedProduct != "Galaxy Book" &&
      this.selectedProduct != "Refrigerator" &&
      this.selectedProduct != "Laundry" &&
      this.selectedProduct != "Cooking" &&
      this.selectedProduct != "Dishwashers"
        ? true
        : false;
    var showMXFamily =
      (this.selectedProduct == "Smartphones" && !this.deviceFamily) ||
      (this.selectedProduct == "Tablets" && !this.deviceFamily);

    var productsLengthName = filteredRes[0]
      ? filteredRes[0].name
        ? false
        : true
      : true;
    var familyLength = $this.deviceFamilyList.length > 0 ? false : true;
    var currentFamilies = $this.deviceFamilyList;
    var productLength = filteredRes.length;

    var source = $this.templates.tsProducts;
    var template = Handlebars.compile(source);
    var compiled = template({
      products: filteredRes,
      length: productLength,
      families: currentFamilies,
      filter: showFilter,
      showFamily: showMXFamily,
      hasProducts: productsLengthName,
      hasFamily: familyLength,
    });

    $("#troubleshooting-guide").html(compiled);

    $("#products-section").hide();

    $("#troubleshooting-guide").show();

    $this.removeOverlay();

    window.supportComponents.steps.setActiveStep(2);

    $this.scrollTo("#troubleshooting-guide");

    $this.events();
  }

  // Filter by type
  filterByTypes(response, device) {

    var $this = this;
    // var wearableProductTypes = ["Earphones", "Smart Watch", "Accessories", "IconX"];
    // var wearableProductTypes = ["Earphones", "Smart Watch", "Accessories", "IconX", "Fitness tracker"];

    var productTypes = [];

    switch (this.selectedProduct) {
      case "Wearables":
        productTypes = [
          "Earphones",
          "Smart Watch",
          "Smart ring",
          "Accessories",
          "IconX",
        ];
        break;
      case "Smartphones":
        switch (this.deviceFamily) {
          case "ts-smartphones-all-family":
            productTypes = [
              "S series",
              "Note series",
              "A series",
              "J series",
              "M series",
              "Fold / Flip",
            ];
            break;
          case "ts-s-series-family":
            productTypes = ["S series"];
            break;
          case "ts-note-series-family":
            productTypes = ["Note series"];
            break;
          case "ts-a-series-family":
            productTypes = ["A series"];
            break;
          case "ts-j-series-family":
            productTypes = ["J series"];
            break;
          case "ts-m-series-family":
            productTypes = ["M series"];
            break;
          case "ts-flip-fold-series-family":
            productTypes = ["Fold / Flip"];
            break;
        }

        break;
      case "Tablets":
        switch (this.deviceFamily) {
          case "ts-tablets-all-family":
            productTypes = ["Tab S", "Tab A", "Rugged", "Other"];
            break;
          case "ts-tablets-tab-s-family":
            productTypes = ["Tab S"];
            break;
          case "ts-tablets-tab-a-family":
            productTypes = ["Tab A"];
            break;
          case "ts-tablets-tab-rugged-family":
            productTypes = ["Rugged"];
            break;
          case "ts-tablets-tab-other-family":
            productTypes = ["Other"];
            break;
        }

        break;
      case "Galaxy Book":
        // productTypes = ["Laptop"]

        // $this.selectedProductId
        // $this.selectedProdName

        // console.log($this.selectedProductId, '$this.selectedProductId')
        // console.log($this.selectedProdName, '$this.selectedProdName')

        $this.selectedProductId = "10497";
        $this.selectedProdName = "Galaxy Book";
        $this.selectedProdImg = "";
        $this.initSession();

        break;
      case "Monitor":
        $this.selectedProductId = "10555";
        $this.selectedProdName = "Monitors";
        $this.selectedProdImg = "";
        $this.initSession();
        break;
      case "TV":
        $this.selectedProductId = "10558";
        $this.selectedProdName = "TVs";
        $this.selectedProdImg = "";
        $this.initSession();
        break;
      case "AV":
        productTypes = ["Soundbar", "Audio", "Blu-Ray", "Speakers"];
        break;
      case "Projector":
        productTypes = ["Projector"];
        break;
      case "Refrigerator":
        $this.selectedProductId = "3445";
        $this.selectedProdName = "Refrigerator";
        $this.selectedProdImg = "";
        $this.initSession();
        break;
      case "Laundry":
        $this.selectedProductId = "3427";
        $this.selectedProdName = "Laundry";
        $this.selectedProdImg = "";
        $this.initSession();
        break;
      case "Cooking":
        $this.selectedProductId = "3227";
        $this.selectedProdName = "Cooking";
        $this.selectedProdImg = "";
        $this.initSession();
        break;
      case "Dishwashers":
        $this.selectedProductId = "3226";
        $this.selectedProdName = "Dishwashers";
        $this.selectedProdImg = "";
        $this.initSession();
        break;

      case "Vacuum Cleaners":
        productTypes = ["Vacuum"];
        break;
    }

    if ($this.deviceFamily) {
      var res = $.grep(response, function (v) {
        // This is to separate 'Other' as there are multiple types classed as 'Other'
        if (
          $this.selectedProduct == "Tablets" &&
          productTypes.includes("Other") > -1
        ) {
          $this.listView = true;
          return (
            productTypes.indexOf(v.deviceFamily.name) > -1 &&
            $this.selectedProduct.indexOf(v.type) > -1
          );
        } else {
          $this.listView = false;
          return productTypes.indexOf(v.deviceFamily.name) > -1;
        }
      });

      return res.sort(function (a, b) {
        var x = a.id;
        var y = b.id;
        return x > y ? -1 : x < y ? 1 : 0;
      });
    } else {
      var res = $.grep(response, function (v) {
        if (device != "") {
          return productTypes.indexOf(v.type) > -1 && device == v.model;
        } else {
          return productTypes.indexOf(v.type) > -1;
        }
      });

      // Sort the latest product on the top
      return res.sort(function (a, b) {
        var x = a.id;
        var y = b.id;
        return x > y ? -1 : x < y ? 1 : 0;
      });
    }
  }

  getScenario() {
    var $this = this;

    // console.log(this.embeddedFAQs, 'FAQ ********')

    this.embeddedFAQs.map((faq, index) => {
      var form = new FormData();
      form.append("scenarioid", faq.id);
      form.append("deviceid", this.selectedProductId);

      this.apiPost(this.scenarioAPI, form, function (data) {
        if (data.success) {
          const response = data.response;

          $this.embeddedFAQsHTMLSteps.push(response[0]);

          // $this.embeddedFAQsHTMLSteps = response.scenarios[0];
        } else {
          console.log("Session Init failed");
          $this.showTsErrorMsg();
        }
      });
    });
  }

  restoreTroubleshooterState() {
   const storedState = JSON.parse(localStorage.getItem("userState"));
   if (storedState) {
       this.sessionId = storedState.sessionId;
       this.selectedProductId = storedState.selectedProductId;
       this.selectedProdName = storedState.selectedProdName;
       this.selectedProdImg = storedState.selectedProdImg;
       this.ref = storedState.ref;
       if (storedState.isBookingStage) {
           this.buildTSOutcomeObject(); // Go directly to booking if troubleshooting is complete
       } else {
           this.initSession(); // Resume troubleshooting
       }
   }
  }


  initSession() {
    console.log('inside initSession');


    this.addOverlay();

    var form = new FormData();
    form.append("deviceid", this.selectedProductId);
    // console.log(this.sessionAPI, 'this session api', this.selectedProductId, 'this session selected product id')
    this.apiPost(this.sessionAPI, form, this.processSessionApiResponse);
  }

  saveTroubleshooterState(isBookingStage = false) {
    const state = {
        sessionId: this.sessionId,
        selectedProductId: this.selectedProductId,
        selectedProdName: this.selectedProdName,
        selectedProdImg: this.selectedProdImg,
        ref: this.ref,
        isBookingStage: isBookingStage
    };
    localStorage.setItem("userState", JSON.stringify(state));
  }

  processSessionApiResponse(data, $this) {
    // console.log(data.response, data)
    // console.log(data.response, 'response in the proce ssesion api response')

    if (data.success) {
      const response = data.response;

      var script = $this.filterByDefaultDevice(response);
      $this.selectedScriptId = script[0].id;
      $this.ref = response.sref;
      $this.sessionId = response.lref;
      $this.initInitalStep();

      // set ref for Qualtrics
      window.state._tsRef = data.response.lref
    } else {
      console.log("Session Init failed");
      $this.showTsErrorMsg();
    }
  }

  filterByDefaultDevice(response) {
    var script = $.grep(response.scripts, function (v) {
      if (v.isDefault == true) {
        return v;
      }
    });

    return script;
  }

  initInitalStep() {
    // console.log('init initInitalStep');

    //var isApi = this.initalStepAPI.replace('#scriptid#', this.selectedScriptId);

    // var  headerObj = { 'x-api-key': this.xApiKey, 'x-session-token': this.xSessionToken  };

    var form = new FormData();

    // Change scripts to process
    if (this.selectedScriptId == 42020) {
      // laptops / computing
      form.append("scriptid", 11136270);
    } else if (this.selectedScriptId == 11132457) {
      // Monitors
      form.append("scriptid", 11136269);
    } else if (this.selectedScriptId == 41616) {
      // TV
      form.append("scriptid", 11136271);
    } else if (this.selectedScriptId == 46561) {
      // Refrigerator
      form.append("scriptid", 11136263);
    } else if (this.selectedScriptId == 44887) {
      // Laundry
      form.append("scriptid", 11136263);
    } else if (this.selectedScriptId == 40256) {
      // Cooking
      form.append("scriptid", 11136263);
    } else if (this.selectedScriptId == 40255) {
      // Dishwashers
      form.append("scriptid", 11136263);
    } else {
      form.append("scriptid", this.selectedScriptId);
    }

    form.append("ref", this.ref);

    // console.log(this.ref, 'checking the ref here')
    this.apiPost(this.initalStepAPI, form, this.processInitalStep);
  }

  sortResponseList(response) {
    // console.log(response 'response.currentScript.id')

    if (response.currentScript.id == 11136271) {
      // TV order for generic list
      var resArr = response.step.answers;
      var index = [6, 8, 5, 3, 1, 2, 7, 9, 0, 4, 10];
      var results = [];

      index.map(function (i) {
        results.push(resArr[i]);
      });

      response.step.answers = results;

      return response;
    } else if (response.currentScript.id == 11136270) {
      // Computing order for generic list
      var resArr = response.step.answers;
      var index = [0, 5, 4, 2, 6, 9, 7, 1, 3, 8];
      var results = [];

      index.map(function (i) {
        results.push(resArr[i]);
      });

      response.step.answers = results;

      return response;
    } else if (response.currentScript.id == 11136269) {
      response.step.answers.map((answer) => {
        if (answer.id == 910851) {
          answer.bodyText = "Voice assistant issues";
        }
      });
      return response;
    } else {
      return response;
    }
  }

  processInitalStep(data, $this) {
    // console.log(data)

    if (data.success) {
      const response = $this.sortResponseList(data.response);

      // console.log(response, 'processInitalStep');

      var faultCode = response.faultCode;

      $this.faultCode =
        faultCode != null && faultCode != "" && $this.faultCode == null
          ? faultCode
          : $this.faultCode;

      //console.log($this.faultCode);
      //console.log(($this.faultCode != null));

      var showBackBtn = $this.selectedStepIds.length > 0;
      // show Skip button when the user reaches the third question in the troubleshooter
      var showSkipTSBtn =
        window.location.pathname.split("/")[1] == "uk"
          ? ($this.numberOfTimeNextStepCalled > 1 &&
              $this.selectedProduct == "Wearables") ||
            ($this.numberOfTimeNextStepCalled > 1 &&
              $this.selectedProduct == "Tablets") ||
            ($this.numberOfTimeNextStepCalled > 1 &&
              $this.selectedProduct == "Smartphones")
            ? true
            : false
          : true;
      // && $this.selectedProduct == 'Wearables' || $this.selectedProduct == 'Tablets' || $this.selectedProduct == 'Smartphones';

      $this.response = response;

      if (response.skippedSteps) {
        // response.skippedSteps.map(step => {})

        if (response.skippedSteps.length > 1) {
          var newStep = [];

          newStep.push(response.skippedSteps[response.skippedSteps.length - 1]);
          $this.skipSteps.push(newStep);
        } else {
          $this.skipSteps.push(response.skippedSteps);
        }
      }

      // auto generate answer (currently using fallback, until Likewize update system)

      response.step.answers.map((a) => {
        if (a.isEvaluateFallback) {
          response.step.answers = [a];
        }
      });

      // generic List not PD list
      var genericList = ["TV", "Galaxy Book", "Monitor"];
      var kissList = ["Refrigerator", "Laundry", "Cooking", "Dishwashers"];
      var isGenericList =
        $this.numberOfTimeNextStepCalled == 0 &&
        genericList.indexOf($this.selectedProduct) > -1
          ? true
          : $this.numberOfTimeNextStepCalled == 1 &&
            kissList.indexOf($this.selectedProduct) > -1
          ? true
          : false;
      var isKiss =
        kissList.indexOf($this.selectedProduct) > -1 &&
        $this.numberOfTimeNextStepCalled == 0
          ? true
          : false;

      var source_qa = $this.templates.tsquestionanswers;
      var template_qa = Handlebars.compile(source_qa);
      var compiled_qa = template_qa({
        response: response,
        showBackBtn: showBackBtn,
        showSkipTSBtn: showSkipTSBtn,
        stepId: response.step.id,
        genericList: isGenericList,
      });

      // further answers info drop downs (embeddedPagelets), e.g. show image
      $this.embeddedPagelets = response.embeddedPagelets;

      // FAQ ID scenario
      $this.embeddedFAQs = response.embeddedFAQs;

      // Evaluate Property
      if (response.evaluateProperty) {
        $this.evaluateProperty = response.evaluateProperty;
      } else if ($this.numberOfTimeNextStepCalled == 0) {
        // reset evaluate property at start point
        $this.evaluateProperty = null;
      }

      if (response.embeddedFAQs) {
        this.getScenario();
      }

      var source_ts = $this.templates.troubleshooter;
      var template_ts = Handlebars.compile(source_ts);
      var compiled_ts = template_ts({
        productName: $this.selectedProdName,
        luxidRef: $this.sessionId,
        questionanswers: compiled_qa,
        genericList: isGenericList,
        kiss: isKiss,
      });

      $("#troubleshooting-guide").html(compiled_ts);

      // These three lines added for Mypage journey
      $("#troubleshooting-guide").show();
      $("#products-section").hide();
      $this.removeOverlay();

      $this.scrollTo("#troubleshooting-guide");

      // Check PopJourney
      if (window.state._popJourney.length >= 1) {
        $this.checkPopJourney(response.step.answers);
      }

      $this.events();
    } else {
      console.log("Init step failed");
      $this.showTsErrorMsg();
    }
  }

  initnextStep(answerId) {
    // console.log(answerId, 'init nextStep');
    // console.log(this.selectedScriptId, 'this.selectedScriptId test')

    /*var nsApi = this.nextStepAPI.replace('#scriptid#', this.selectedScriptId);
        nsApi = nsApi.replace('#answerid#', answerId);
        var  headerObj = { 'x-api-key': this.xApiKey, 'x-session-token': this.xSessionToken  };*/

    // skip to speak purchase locator

    var form = new FormData();
    form.append("answerid", answerId);
    form.append("ref", this.ref);
    this.apiPost(this.nextStepAPI, form, this.processNextStep);
  }

  processNextStep(data, $this) {
    // console.log(data, 'processNextStep test');

    if (data.success) {
      const response = data.response;

      $this.numberOfTimeNextStepCalled += 1;

      // console.log(response, 'steps test')

      if (!response.isEnd) {
        $this.processInitalStep(data, $this);
      } else {
        $this.showFinalStep(response);
      }
    } else {
      console.log("Next step failed");
      $this.showTsErrorMsg();
    }
  }

  showFinalStep(response) {
    // console.log(response, 'FinalStep test');

    var $this = this;

    var faultCode = response.faultCode;

    $this.faultCode =
      faultCode != null && faultCode != "" && $this.faultCode == null
        ? faultCode
        : $this.faultCode;

    if (response.embeddedPagelets) {
      $this.embeddedPagelets = response.embeddedPagelets;
    }

    if (response.embeddedFAQs) {
      $this.embeddedFAQs = response.embeddedFAQs;

      this.getScenario();
    }

    var showBackBtn = $this.selectedStepIds.length > 0;
    var showRef = $(".btn-ts-pagelet");

    var source_qa = $this.templates.tsquestionanswers;
    var template_qa = Handlebars.compile(source_qa);
    var compiled_qa = template_qa({
      response: response,
      showBackBtn: showBackBtn,
      showRef: showRef,
    });

    $this.isOutcomeSuccessful = response.outcomeSuccessful;

    $("#tsQAWrapper").html(compiled_qa);

    const attributes = {
      "data-omni-type": "microsite_contentinter",
      "data-omni": "support:repair:TS-Book a repair",
      "ga-la": "support:repair:TS-Book a repair",
      "ga-ca": "content click",
      title: "Book a repair",
      "ga-ac": "feature",
    };

    const contactAttributes = {
      "data-omni-type": "microsite_contentinter",
      "data-omni": "support:repair:TS-Contact us",
      "ga-la": "support:repair:TS-Contact us",
      "ga-ca": "content click",
      title: "Contact us",
      "ga-ac": "feature",
    };

    const chatWithUsAttributes = {
      "data-omni-type": "microsite_contentinter",
      "data-omni": "support:repair:TS-Chat with us",
      "ga-la": "support:repair:TS-Chat with us",
      "ga-ca": "content click",
      title: "Chat with us",
      "ga-ac": "feature",
    };

    const button = $("#tsQAWrapper .ts-message");
    // $this.setAttributes(button, attributes);

    if (button.length > 0) {
      button.html().includes("contact us")
        ? $this.setAttributes(button, contactAttributes)
        : button.html().includes("Chat with us")
        ? $this.setAttributes(button, chatWithUsAttributes)
        : $this.setAttributes(button, attributes);
    }

    if (!$("#purchaselocator").length) {
      $this.scrollTo("#troubleshooting-guide");
    }

    $this.events();
    //$this.buildTSOutcomeObject(response);
  }

  buildTSOutcomeObject() {
    var $this = this;

    if ($this.isOutcomeSuccessful) {
      // window.location.href="https://www.samsung.com/"+site+"/support/contact";
      window.open(
        "https://www.samsung.com/" + site + "/support/contact",
        "_blank"
      );
    } else {
      //this is for battery replacement
      const batteryReplacement = window.state.isBatteryReplacement == true ? "Battery Replacement" : "";
      //'Samsung/' needs to be removed once convert all categories to API, code change required on tsinterpreter page also
      $this.tsOutcome = {
        type: "tsOutcome",
        outcome: "Unsuccessful",
        faultCode: $this.faultCode != null ? $this.faultCode.code : "",
        sessionId: $this.sessionId,
        symptomCode1: "",
        symptomCode2: "",
        symptomCode3: "",
        warrantyException: "",
        product: "Samsung/" + $this.selectedProdName,
        //"script": response.currentScript.name,
        selectedIssue: $this.faultCode != null ? $this.faultCode.name
        : batteryReplacement ? batteryReplacement : "",
      };

      $this.initSymptomCodeApi();
    }
  }

  initSymptomCodeApi() {
    //console.log('inside symptomcode API');
    //console.log(this.tsOutcome);

    /**var scApi = this.symptomCodeAPI.replace('#deviceid#', this.selectedProductId)+'&faultCode='+this.tsOutcome.faultCode;;

        var  headerObj = { 'x-api-key': this.xApiKey, 'x-session-token': this.xSessionToken  };

        this.apiGet(scApi, headerObj, this.processSymptomCodeApi);**/

    var form = new FormData();
    form.append("deviceid", this.selectedProductId);
    form.append("faultcode", this.tsOutcome.faultCode);
    form.append("ref", this.ref);
    this.apiPost(this.symptomCodeAPI, form, this.processSymptomCodeApi);
  }

  processSymptomCodeApi(data, $this) {
    //console.log('Process SymptomcodeApi');
    // console.log(data);

    if (data.success) {
      const response = data.response;

      $this.tsOutcome.symptomCode1 =
        response.symptomCodes.symptomCode1 != null
          ? response.symptomCodes.symptomCode1
          : "99";
      $this.tsOutcome.symptomCode2 =
        response.symptomCodes.symptomCode2 != null
          ? response.symptomCodes.symptomCode2
          : "99";
      $this.tsOutcome.symptomCode3 =
        response.symptomCodes.symptomCode3 != null
          ? response.symptomCodes.symptomCode3
          : "99";
      $this.tsOutcome.warrantyException =
        response.symptomCodes.warrantyException != null
          ? response.symptomCodes.warrantyException
          : "";

      // console.log($this.tsOutcome);

      $this.tsInterpreter = new TsInterpreter($this.tsOutcome);

      setTimeout(() => {
        $this.tsInterpreter.handleClickedContactUs();
      }, 1000);
    } else {
      console.log("Sympton code API failed");
      $this.showTsErrorMsg();
    }
  }

  // For handling back button we use this method
  initscriptStep(skip = false, answerId = "") {
    //console.log('init script Step');

    var $this = this;

    window.state.isBatteryReplacement = false;

    if ($this.selectedStepIds.length > 0) {
      if (skip) {
        var form = new FormData();
        // one case to skip the skip (this case is found on s21 fe 5g)
        if (
          skip.id == $this.skipSteps[$this.skipSteps.length - 1][0].id &&
          answerId == "886883"
        ) {
          $this.skipReturned = "true";
        } else {
          $this.skipReturned = "false";
        }

        form.append("stepid", skip.id);
        form.append("scriptid", skip.scriptId);
        form.append("ref", $this.ref);
        if (
          skip.id == $this.skipSteps[$this.skipSteps.length - 1][0].id &&
          $this.evaluateProperty == null
        ) {
          form.append("returned", $this.skipReturned);
        }
        this.apiPost($this.scriptStepAPI, form, $this.processScriptStep);
      } else {
        var stepId = $this.selectedStepIds.pop();

        /**var ssApi = $this.scriptStepAPI.replace('#scriptid#', $this.selectedScriptId);
                ssApi = ssApi.replace('#stepid#', stepId);

                var  headerObj = { 'x-api-key': $this.xApiKey, 'x-session-token': $this.xSessionToken  };

                $this.apiGet(ssApi, headerObj, $this.processScriptStep); **/

        var form = new FormData();
        form.append("stepid", stepId);
        form.append("ref", $this.ref);
        this.apiPost($this.scriptStepAPI, form, $this.processScriptStep);
      }
    }
  }

  processScriptStep(data, $this) {
    // console.log(data,'processScriptStep');
    if (data.success) {
      $this.numberOfTimeNextStepCalled -= 1;
      $this.processInitalStep(data, $this);
    } else {
      console.log("Script Step failed");
      $this.showTsErrorMsg();
    }
  }

  showTsErrorMsg() {
    var source_tse = this.templates.tsErrorMsg;
    var template_tse = Handlebars.compile(source_tse);
    var compiled_tse = template_tse({
      site: site,
    });

    $("#troubleshooting-guide").html(compiled_tse);
    $("#troubleshooting-guide").show();
    this.removeOverlay();
    this.scrollTo("#troubleshooting-guide");
  }

  showTSResolved() {
    var source_tsr = this.templates.tsResolved;
    var template_tsr = Handlebars.compile(source_tsr);
    var compiled_tsr = template_tsr({
      site: site,
    });

    $("#troubleshooting-guide").html(compiled_tsr);
    $("#troubleshooting-guide").show();
    this.removeOverlay();
    this.scrollTo("#troubleshooting-guide");
  }

  checkPopJourney(steps) {
    steps.map(step => {
      if (window.state._popJourney.includes(step.id.toString())) {
        let popList = window.state._popJourney.filter(id => id != step.id)
        window.state._popJourney = popList
      }
    })
  }

  apiGet(url, headerObj, callback) {
    var $this = this;

    // console.log(callback, 'callback')

    $.ajax({
      type: "GET",
      url: url,
      crossDomain: true,
      xhrFields: {
        withCredentials: false,
      },
      headers: headerObj,

      success: (response, textStatus, xhr) => {
        if (xhr.status === 200 && textStatus === "success") {
          callback(response, $this);
        } else {
          console.error(response);
        }
      },
      error: (response) => {
        console.error(response);
      },
    });
  }

  apiPost(url, form, callback) {
    var $this = this;

    //   $this.skipSteps[$this.skipSteps.length - 1][1]

    for (var value of form.values()) {
      // console.log(value);
    }

    $.ajax({
      type: "POST",
      url: url,
      data: form,
      processData: false,
      contentType: false,
      dataType: "json",
      type: "POST",
      success: (response, textStatus, xhr) => {
        if (xhr.status === 200 && textStatus === "success") {
          callback(response, $this);
        } else {
          console.error(response);
        }
      },
      error: (response, textStatus, xhr) => {
        console.error(response, textStatus, xhr);
      },
    });
  }

  setAttributes(element, attributes) {
    Object.keys(attributes).forEach((attribute) => {
      $(element).attr(attribute, attributes[attribute]);
    });
  }

  scrollTo(elem) {
    var stepsSummaryHeight = $(".floating-navigation").hasClass(
      "floating-navigation--fixed"
    )
      ? $(".steps-wrapper").outerHeight()
      : 0;

    stepsSummaryHeight += $(".summary-wrapper").is(":visible")
      ? $(".summary-wrapper").outerHeight()
      : 0;

    var scrollTop = $(elem).position().top - stepsSummaryHeight;

    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: scrollTop,
        },
        100,
        function () {}
      );
    }, 500);
  }

  addOverlay() {
    if ($(".s-layer-dimmed").length == 0) {
      if ($("footer.footer").length > 0) {
        $('<div class="s-layer-dimmed"></div>').insertAfter("footer.footer");
      }

      if ($("footer#footer").length > 0) {
        $('<div class="s-layer-dimmed"></div>').insertAfter("footer#footer");
      }
    }
    $(".s-layer-dimmed").show();

    $(".lds-ring2").show();
  }

  removeOverlay() {
    if ($(".s-layer-dimmed").length > 0) {
      $(".s-layer-dimmed").hide();
      $(".s-layer-dimmed").remove();
      $(".lds-ring2").hide();
    }
  }

  // chatbot
  handleClickedChatToAgent(postedData) {
    var $this = this;
    // console.log("chat -> interpreter " + this.openChat);
    // console.log("chat -> mobile");
    // console.log("_c_656090b343743730688d8a00 -> Yes");
    // console.log("_c_65771084f23a9b229d7cc53c -> " + window.state.product);
    window.sprChat("updateClientContext", {
      _c_656090b343743730688d8a00: ["Yes"], //Mobile Yes or No
      _c_656090f243743730688db608: ["No"], //HA Yes or No
      _c_6560912b43743730688ddf16: ["No"], //TV Yes or no
      _c_6560915e43743730688e084d: ["No"], //Computer Yes or no
      // sub categroy
      _c_65771084f23a9b229d7cc53c: [window.state.product],
      _c_657710b3f23a9b229d7d07cf: [""],
      _c_657710f2f23a9b229d7d6824: [""],
      _c_65771135f23a9b229d7dd8c0: [""],
      // filter value for reports
      _c_65a7cc9c3bd1664f2fdcfaa6: ["Yes"],
    });
    if (!this.openChat) {
      //   console.log("chat if");
      window.sprChat("updateClientContext", {
        _c_647484e02b41c27ed4ed9a54: ["Yes"], //Key - custom field name, Value - Blank
      });

      window.sprChat("openNewConversation", {
        initialMessages: [
          {
            message: "Hi, I want to speak to a Samsung Support Expert",
            isSentByUser: true,
          },
        ],
      });
    } else {
      //   console.log("chat else");
      window.sprChat("open");
    }
    $this.openChat = true;
  }
}
